import React from "react";
export const VendorQuotationExcelDetailContext = React.createContext(null);

export const useVendorQuotationExcelDetailContext = () => {
  const context = React.useContext(VendorQuotationExcelDetailContext);

  if (!context)
    throw new Error("Vendor Quotation Excel Detail Context not provided!");

  return context;
};
